<template>
  <ItemPage
    title="Tipo de tags - Tags"
    size="sm"
    :actions="actions"
  >
    <v-form
      ref="form"
    >
      <v-text-field
        v-model="tagtype.name"
        :rules="rulesName"
        :disabled="!tagTypesUpdate"
        label="Nome"
        @input="checkUpdate"
      />
      <br>
      <template v-if="tagsView">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise pelo nome da tag"
          single-line
          hide-details
        />
      </template>
    </v-form>
    <v-simple-table
      v-if="tagsView"
      fixed-header
    >
      <template v-if="loading">
        <Load :loadingmsg="loadingMsg" />
      </template>
      <div
        v-else
        class="mr-5 ml-5"
      >
        <v-data-table
          :headers="headers"
          :items="tags"
          :items-per-page="10"
          :search="search"
          item-key="id"
          @click:row="editTag($event)"
        />
      </div>
    </v-simple-table>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import NewTagDialog from '@/components/settings/NewTagDialog.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import utils from '@/api/utils.js'

export default {
  components: {
    Load,
    ItemPage
  },
  data () {
    return {
      btnDisable: true,
      renderComponent: 0,
      rulesName: [
        value => !!value || 'Preenchimento obrigatório.',
        value => (value && value.length >= 3) || 'Min 3 caracteres'
      ],
      dialogAddTag: false,
      loading: false,
      loadingSave: false,
      update: false,
      currentTagtype: {},
      tagtype: {},
      tags: [],
      formError: [],
      search: '',
      headers: [
        {
          text: 'id',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome da Tag',
          align: 'start',
          value: 'name'
        }
      ]
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    tagsView () {
      return utils.checkPermissions('tags.view-any')
    },
    tagsCreate () {
      return utils.checkPermissions('tags.create')
    },
    tagTypesUpdate () {
      return utils.checkPermissions('tag-types.update-any')
    },
    tagTypesDelete () {
      return utils.checkPermissions('tag-types.delete')
    },

    actions () {
      return [
        {
          label: 'Adicionar Tag',
          action: this.openNewTagDialog,
          icon: 'mdi-plus',
          disabled: !this.tagsCreate
        },
        {
          label: 'Atualizar',
          action: this.updateTagType,
          icon: 'mdi-floppy',
          disabled: this.btnDisable
        },
        {
          label: 'Deletar',
          action: this.deleteTagType,
          icon: 'mdi-delete',
          disabled: !this.tagTypesDelete
        }
      ]
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    async fetchAll () {
      await this.getTagType()
    },
    async getTagType () {
      this.loading = true
      this.loadingMsg = 'Carregando lista de tags...'
      try {
        const response = await this.$api.getTagType(this.id)
        this.tagtype = response
        this.currentTagtype = utils.currentData(response)
        this.tags = response.tags
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter os tipos de tags, tente novamente mais tarde.', color: 'red' })
      }
      this.loading = false
    },
    editTag (event) {
      this.$router.push({ name: 'tags.id', params: { id: event.id } })
    },
    openDialogAddTag () {
      this.renderComponent += 1
      this.dialogAddTag = true
    },
    sizes (data) {
      return utils.size(data)
    },
    checkUpdate () {
      const data = utils.newData(this.tagtype, this.currentTagtype)
      if (utils.size(data) > 0) {
        this.btnDisable = false
      } else {
        this.btnDisable = true
      }
      return data
    },
    async deleteTagType () {
      this.$dialog.confirm('Apagar tipo de tag?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          try {
            await this.$api.deleteTagType(this.id)
            this.$store.dispatch('setSnackBar', { text: 'Tipo de Tag excluida com sucesso.' })
            this.$router.back()
          } catch {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível Excluir, tente novamente mais tarde.', color: 'red' })
          }
        })
        .show()
    },
    async updateTagType () {
      const validate = await this.validate()
      if (validate === false) {
        return false
      }
      const data = this.checkUpdate()
      try {
        await this.$api.updateTagType(this.id, data)
        this.$store.dispatch('setSnackBar', { text: 'Atualizado com sucesso.' })
        this.fetchAll()
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível atualizar, tente novamente mais tarde.', color: 'red' })
      }
    },
    validate () {
      return this.$refs.form.validate()
    },
    openNewTagDialog () {
      this.$dialog.custom(NewTagDialog).with({ title: 'tag' }).show()
        .then((tag) => tag && this.newTag(tag))
    },
    async newTag (data) {
      this.loadingMsg = 'Salvando...'
      data.tag_type_id = await this.id
      try {
        await this.$api.newTag(data)
        this.$store.dispatch('setSnackBar', { text: 'Salvo com sucesso.' })
        this.fetchAll()
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível salvar, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
